import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddChassisHeightModal from "./components/AddChassisHeightModal";
import ChassisTable from "./components/ChassisTable";
import {
  selectChassisHeightList,
  selectChassisHeightLoading,
  selectChassisHeightMeta,
} from "./redux/selector";
import chassisHeightSaga from "./redux/saga";
import { chassisHeightActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const ChassisHeight = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: chassisHeightSaga,
  });

  const rows = useSelector(selectChassisHeightList);
  const loading = useSelector(selectChassisHeightLoading);
  const meta = useSelector(selectChassisHeightMeta);

  useEffect(() => {
    dispatch(chassisHeightActions.getChassisHeightList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(chassisHeightActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.CHASSIS_HEIGHT")}
            iconPosition="end"
          />
          <ActionBar
            onAddClick={() => dispatch(chassisHeightActions.openAddModal())}
          />
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <ChassisTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddChassisHeightModal />
    </Box>
  );
};

export default ChassisHeight;
